import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { action = 'create', coupon } = payload || {}

    if (action === 'create') {
      return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_COUPONS_ADD)
    }

    if (action === 'delete') {
      return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_COUPONS_DELETE, {
        pathParams: { id: coupon?.id },
      })
    }

    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_COUPONS_UPDATE, {
      pathParams: { id: coupon?.id },
    })
  },

  method(payload) {
    const { action = 'create' } = payload || {}
    if (action === 'create') return 'POST'
    if (action === 'delete') return 'DELETE'
    return 'POST' // update is POST in V3 for deals/coupons generally, or PUT. Let's use POST as per convention for coupons update in this system unless specified
  },

  format(payload) {
    const { action = 'create', coupon } = payload || {}

    if (action === 'delete') return {}

    return {
      code: coupon.code,
      discount: coupon.discount,
      type: coupon.type,
      description: coupon.description || '',
      restaurantId: coupon.storeId === 'all' ? null : coupon.storeId,
      validFrom: coupon.startDate || undefined,
      validTo: coupon.endDate || undefined,
      usageLimit: coupon.nbAppliance || -1,
      userLimit: coupon.userLimit || -1,
      active: coupon.active !== undefined ? coupon.active : (coupon.isActive !== undefined ? coupon.isActive : true),
      firstOrderOnly: coupon.firstOrderOnly || false,
      minOrderAmount: coupon.minOrderAmount || 0,
      maxDiscountAmount: coupon.maxDiscountAmount || 0,
      metadata: {
        // title: coupon.title,
        merchandSupportDiscount: coupon.merchandSupportDiscount,
        isVisible: coupon.isVisible !== undefined ? coupon.isVisible : true,
      }
    }
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Une erreur est survenue',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Coupon enregistré avec succès',
      data: raw.data,
    }
  },
}
